import { MilestoneDateEditor } from "@/containers/Project/components";
import * as S from "@/containers/Project/components/styled";
import { ProjectUserPermissions } from "@/enums";
import { findTargetMilestoneRecursive } from "@/helpers";
import { projectMilestoneType } from "@/propTypes";
import * as GlobalS from "@/sharedStyled";
import _ from "lodash";
import { func, object } from "prop-types";

const DATE_TYPE = {
  actual: "actualDate",
  target: "targetDate",
};

export const MilestoneDates = ({
  milestone,
  canUser,
  project,
  setProject,
}) => {
  const updateProjectContext = (
    { milestoneId, date },
    dateType
  ) => {
    const updatedProject = _.cloneDeep(project);

    for (const schedule of updatedProject.schedules) {
      const targetMilestone = findTargetMilestoneRecursive(
        schedule.milestones,
        milestoneId
      );

      if (targetMilestone) {
        targetMilestone[dateType] = date;

        break;
      }
    }

    setProject(updatedProject);
  };

  return (
    <GlobalS.FlexDiv style={{ alignItems: "top" }}>
      <MilestoneDateEditor
        data-test-id="target-date-milestone-edit"
        milestone={{ ...milestone, projectId: project.id }}
        intlId={"projectMilestoneTable.target"}
        datePropertyName={"targetDate"}
        onSaved={(projectMilestone) =>
          updateProjectContext(projectMilestone, DATE_TYPE.target)
        }
        disabled={
          !canUser(
            ProjectUserPermissions.EditMilestoneTargetDates,
            milestone
          ) || milestone.targetDateLocked
        }
      />
      <MilestoneDateEditor
        data-test-id="target-date-milestone-edit"
        milestone={{ ...milestone, projectId: project.id }}
        intlId={"projectMilestoneTable.actual"}
        datePropertyName={"actualDate"}
        disabled={
          !canUser(ProjectUserPermissions.EditMilestoneActualDates, milestone)
        }
        onSaved={(projectMilestone) =>
          updateProjectContext(projectMilestone, DATE_TYPE.actual)
        }
      />
      <S.StyledSpacer $width={32}></S.StyledSpacer>
    </GlobalS.FlexDiv>
  );
};

MilestoneDates.propTypes = {
  milestone: projectMilestoneType,
  canUser: func,
  project: object,
  setProject: func,
};
